import Vue from 'vue'
import Router from 'vue-router'

import router_main from './route/main'
import router_EVENTS from './route/EVENTS'



// import './assets/css/kiken/kiken.css'

Vue.use(Router)

var allRoutes = []
allRoutes = allRoutes.concat(
    router_main,
    router_EVENTS
)

const routes = allRoutes


export default new Router({
    routes
})